export const PATH_PREFIX = '/jupiter'
export const PATH_USER_CENTER = '/usercenter'
export const PATH_SSO = '/sso'
// export const PATH_ACCOUNT = '/account'
export const PATH_SL = '/sl'
// export const PATH_DM = '/dm'
export const PATH_DEVICE = '/device'
export const PATH_SDR = '/sdr'
export const PATH_FILE = '/fileserver'
export const PATH_ACCREDIT = '/accredit'
export const PATH_PAYMENT = '/payment'
export const PATH_EDU = '/edu'
